import { enqueueSnackbar } from 'notistack'
import { apiBase } from '../services/apiBase'
import { DOMAIN } from './api'

export const fetchTags = async (storeId) => {
	try {
		const response = await apiBase.get(`${DOMAIN}/storeManager/tags/${storeId}`)

		if (Array.isArray(response)) {
			return response
		}
		return []
	} catch (error) {
		console.error('Error fetching tags:', error)
		enqueueSnackbar(error.response?.data?.message, {
			variant: 'error',
		})
		throw error
	}
}
